import { inject, Injectable, Signal } from '@angular/core';
import { SelectedCustomer, UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AppState } from '../../shared/models';
import { CustomerSwitch, observeCustomerSwitches } from '../../shared/utils/customer-switch.utils';

@Injectable({
  providedIn: 'root',
})
export class BlightCustomerContextService {
  private readonly appStore = inject(Store<AppState>);

  readonly customer: Signal<SelectedCustomer | undefined> = this.appStore.selectSignal(UserSelectors.selectCustomer);
  readonly customerSwitches$: Observable<CustomerSwitch> = observeCustomerSwitches(this.appStore);
}
